/** ============================================================= *
 *  ---------------------- IMPORT - START ----------------------- *
 *  ============================================================= */
import 'what-input'
import jQuery from 'jquery'
import Foundation from 'foundation-sites'
import intlTelInput from 'intl-tel-input/intlTelInputWithUtils'
import 'owl.carousel'
import Swiper from 'swiper'
import { Navigation, Pagination } from 'swiper/modules'
import { setHrefs } from './functions/data-hrefs'
import { initEqualizeContent } from './functions/equalizer'
import { initTelephoneInput } from './functions/intl-tel-input'
import { initDatepickerInput } from './functions/datepicker'
import { enableNegativeMargins } from './functions/negative-margins'
import { mapStyles } from './functions/map-styles'
/** ============================================================= *
 *  ----------------------- IMPORT - END ------------------------ *
 *  ============================================================= */



/** ============================================================= *
 *  ------------ GLOBAL VARIABLES DECLARATION - START ----------- *
 *  ============================================================= */
const THEME_FOLDER = "../wp-content/themes/hcrma_v1"
const PHONE_FIELD = ".codesm-phone-field"
const DATEPICKER_FIELD = ".codesm-datepicker-field"
const DATEPICKER_FORMAT = "mm/dd/yyyy"
const EQUALIZE_CONTENT = ".codesm-equalize-content"

Foundation.addToJquery(jQuery)
Swiper.use([Navigation, Pagination])
window.intlTelInput = intlTelInput
window.setHrefs = setHrefs
window.initEqualizeContent = initEqualizeContent
window.initTelephoneInput = initTelephoneInput
window.initDatepickerInput = initDatepickerInput
window.enableNegativeMargins = enableNegativeMargins
window.mapStyles = mapStyles
// window.enableCallrailTracking = enableCallrailTracking
/** ============================================================= *
 *  ------------- GLOBAL VARIABLES DECLARATION - END ------------ *
 *  ============================================================= */



jQuery(document).ready(function () {
	jQuery(document).foundation();
	triggerThemeFunctions();

	// ADD YOUR CODE HERE
	// 
	//

	//swipers
	var swiper = new Swiper('.year-swiper', {
		slidesPerView: 'auto',
		spaceBetween: 10,
		navigation: {
			nextEl: '.swiper-button-next',
			prevEl: '.swiper-button-prev',
		},
	});

	var projects = new Swiper('#projects .swiper-container', {
		direction: 'horizontal',
		slidesPerView: 1,
		slidesPerColumn: 1,
		spaceBetween: 50,
		autoplay: false,
		loop: false,
		navigation: {
			nextEl: "#projects .swiper-button-next",
			prevEl: "#projects .swiper-button-prev",
		},
		breakpoints: {
			640: {
				slidesPerView: 1,
			},
			1024: {
				slidesPerView: 1,
			},
			1200: {
				slidesPerView: 1,
			},
			1440: {
				slidesPerView: 1,
			},
		},
		on: {
			init: function () {
				setTimeout(function () {
					window.dispatchEvent(new Event('resize'));
				}, 500);
			},
		},
		pagination: {
			el: "#projects .swiper-pagination",
			type: "bullets",
			clickable: true
		},
	});

	var hero_slider = new Swiper('#hero-slider .swiper-container', {
		direction: 'horizontal',
		slidesPerView: 1,
		slidesPerColumn: 1,
		spaceBetween: 0,
		autoplay: false,
		loop: true,
		navigation: {
			nextEl: "#hero-slider .swiper-button-next",
			prevEl: "#hero-slider .swiper-button-prev",
		},
		breakpoints: {
			640: {
				slidesPerView: 1,
			},
			1024: {
				slidesPerView: 1,
			},
			1200: {
				slidesPerView: 1,
			},
			1440: {
				slidesPerView: 1,
			},
		},
		on: {
			init: function () {
				setTimeout(function () {
					window.dispatchEvent(new Event('resize'));
				}, 500);
			},
		},
		pagination: {
			el: "#hero-slider .swiper-pagination",
			type: "bullets",
			clickable: true
		},
	});

	var gallery = new Swiper('#gallery .swiper-container', {
		direction: 'horizontal',
		slidesPerView: 1,
		slidesPerColumn: 1,
		spaceBetween: 30,
		autoplay: false,
		loop: false,
		navigation: {
			nextEl: "#gallery .swiper-button-next",
			prevEl: "#gallery .swiper-button-prev",
		},
		breakpoints: {
			640: {
				slidesPerView: 1,
			},
			1024: {
				slidesPerView: 2,
			},
			1200: {
				slidesPerView: 3,
			},
			1440: {
				slidesPerView: 4,
			},
		},
		on: {
			init: function () {
				setTimeout(function () {
					window.dispatchEvent(new Event('resize'));
				}, 500);
			},
		},
		pagination: {
			el: "#gallery .swiper-pagination",
			type: "bullets",
			clickable: true
		},
	});

	/* ------------------------------------------------------------------------
	 * MEETINGS PAGE
	 * ------------------------------------------------------------------------ */

	// === Navigation arrow clicks ===
	var navContainer = jQuery('#current-year-meetings .year-navigation');
	var prevBtn = jQuery('#current-year-meetings .year-prev');
	var nextBtn = jQuery('#current-year-meetings .year-next');

	if (prevBtn.length && nextBtn.length && navContainer.length) {
		prevBtn.on('click', function (e) {
			e.preventDefault();
			var active = navContainer.find('.year.active');
			var prev = active.prev('.year');
			if (prev.length) {
				prev.trigger('click');
			}
		});

		nextBtn.on('click', function (e) {
			e.preventDefault();
			var active = navContainer.find('.year.active');
			var next = active.next('.year');
			if (next.length) {
				next.trigger('click');
			}
		});
	}

	// === Current year meeting month filters ===
	var monthLinks = jQuery('#current-year-meetings .year-navigation .year');
	var meetings = jQuery('#current-year-meetings .meeting-card');

	if (monthLinks.length) {
		monthLinks.on('click', function (e) {
			e.preventDefault();

			monthLinks.removeClass('active');
			jQuery(this).addClass('active');

			var month = jQuery(this).data('month');
			meetings.each(function () {
				var card = jQuery(this);
				card.toggle(card.data('month') === month);
			});
		});

		// trigger default active
		var activeLink = jQuery('#current-year-meetings .year-navigation .year.active');
		if (activeLink.length) {
			activeLink.trigger('click');
		} else {
			// If no active link (e.g. current month has no meetings), select the first available one
			monthLinks.first().trigger('click');
		}
	}
	// === Archive meetings datepicker and search filter ===
	var input = jQuery('.meeting-date-selection');
	input.on('click', function () {
		if (this.showPicker) this.showPicker();
	});

	input.on('change', function () {
		var value = this.value;
		if (value) {
			var date = new Date(value);
			var day = ('0' + date.getDate()).slice(-2);
			var month = ('0' + (date.getMonth() + 1)).slice(-2);
			var year = date.getFullYear();
			jQuery(this).val(year + '-' + month + '-' + day);
		}
	});

	var dateInput = jQuery('.meeting-date-selection');
	var searchInput = jQuery('#archive-meetings .meeting-search');
	var meetings_card = jQuery('#archive-meetings .meeting-card');

	function filterArchiveMeetings() {
		var selectedDate = dateInput.val() || '';
		var searchTerm = searchInput.val() ? searchInput.val().toLowerCase() : '';
		var visibleCount = 0;

		meetings_card.each(function () {
			var card = jQuery(this);
			var matchDate = true;
			var matchSearch = true;

			if (selectedDate) {
				matchDate = card.data('date') === selectedDate;
			}

			if (searchTerm) {
				matchSearch = card.text().toLowerCase().indexOf(searchTerm) !== -1;
			}

			var isVisible = matchDate && matchSearch;
			card.toggle(isVisible);
			if (isVisible) visibleCount++;
		});

		// Show/hide "No meetings found" message
		var noResultsMsg = jQuery('#archive-meetings .no-meetings-found');
		if (noResultsMsg.length === 0) {
			// Create the message element if it doesn't exist
			noResultsMsg = jQuery('<div class="no-meetings-found" style="text-align: center; padding: 40px 20px; font-size: 18px; color: #666;">No meetings found</div>');
			jQuery('#archive-meetings .meeting-card').first().parent().append(noResultsMsg);
		}
		noResultsMsg.toggle(visibleCount === 0);
	}

	dateInput.on('input', filterArchiveMeetings);
	searchInput.on('input', filterArchiveMeetings);

	/* ------------------------------------------------------------------------
	 * PROJECTS PAGE
	 * ------------------------------------------------------------------------ */
	jQuery('.progress-container').each(function () {
		var bar = jQuery(this);
		var percent = bar.data('percent');
		var fill = bar.find('.progress-fill');
		var text = bar.find('.progress-text');

		fill.css('width', percent + '%');
		text.text(percent + '% Completed');
	});

	/* ------------------------------------------------------------------------
	 * HISTORY & MILESTONES TIMELINE
	 * ------------------------------------------------------------------------ */
	var dots = jQuery('.dot');
	var infoBox = jQuery('.timeline-info-card');
	var infoImage = jQuery('#infoImage');
	var infoTitle = jQuery('#infoTitle');
	var infoDesc1 = jQuery('#infoDesc1');
	var infoDesc2 = jQuery('#infoDesc2');

	var activeDot = null;
	infoBox.hide();

	dots.on('click', function () {
		var $this = jQuery(this);

		if (activeDot && activeDot.is($this)) {
			infoBox.hide();
			activeDot.removeClass('active');
			activeDot = null;
			return;
		}

		infoImage.attr('src', $this.data('image'));
		infoTitle.text($this.data('title'));
		infoDesc1.text($this.data('desc1'));
		infoDesc2.text($this.data('desc2'));

		infoBox.show();
		if (activeDot) activeDot.removeClass('active');
		$this.addClass('active');
		activeDot = $this;
	});

	/* ------------------------------------------------------------------------
	 * SEARCH FORM TOGGLE
	 * ------------------------------------------------------------------------ */
	jQuery('.search-icons i.fa-magnifying-glass').on('click', function (e) {
		e.preventDefault();
		jQuery('.search-form').removeClass('hide');
		jQuery(this).addClass('hide');
		jQuery('.close-search').removeClass('hide');
		jQuery('.search-form input[type="text"]').focus();
	});

	jQuery('.close-search').on('click', function (e) {
		e.preventDefault();
		jQuery('.search-form').addClass('hide');
		jQuery(this).addClass('hide');
		jQuery('.search-icons i.fa-magnifying-glass').removeClass('hide');
	});

	jQuery('.close-notice').on('click', function () {
		jQuery('.header-top').fadeOut();
	});

	/* ------------------------------------------------------------------------
	 * PROCUREMENT CONTRACTS AWARDED
	 * ------------------------------------------------------------------------ */
	var latestYear = jQuery('#procurement-contracts-awarded .year-navigation a.year').first().data('year');
	jQuery('#procurement-contracts-awarded .about-card-container').hide();
	jQuery(`#procurement-contracts-awarded .about-card-container[data-year="${latestYear}"]`).show();

	jQuery('#procurement-contracts-awarded .year-navigation a.year').on('click', function (e) {
		e.preventDefault();

		jQuery('#procurement-contracts-awarded .year-navigation a.year').removeClass('active');
		jQuery(this).addClass('active');

		var selectedYear = jQuery(this).data('year');
		jQuery('#procurement-contracts-awarded .about-card-container').hide();
		jQuery(`#procurement-contracts-awarded .about-card-container[data-year="${selectedYear}"]`).fadeIn(200);
	});


	/* ------------------------------------------------------------------------
	 * DOCUMENTS PAGE - YEAR NAVIGATION (AJAX)
	 * ------------------------------------------------------------------------ */
	var yearLinks = jQuery('#documents .year-navigation a.year');
	if (yearLinks.length) {
		yearLinks.on('click', function (e) {
			e.preventDefault();
			var selectedYear = jQuery(this).data('year');
			var container = jQuery('#documents-container');
			var category = container.data('category') || '';

			console.log('Selected Year Document:', selectedYear);

			// Update active class
			yearLinks.removeClass('active');
			jQuery(this).addClass('active');

			// Show loading state
			container.html('<div class="row"><div class="columns large-12 text-center" style="padding: 60px 0;"><p>Loading documents...</p></div></div>');

			// AJAX request to load documents
			jQuery.ajax({
				url: hcrmaDocuments.ajaxurl,
				type: 'POST',
				data: {
					action: 'load_documents_by_year',
					year: selectedYear,
					category: category,
					nonce: hcrmaDocuments.nonce
				},
				success: function (response) {
					if (response.success) {
						container.html(response.data);
						// Re-initialize any equalizer if needed
						if (typeof window.initEqualizeContent === 'function') {
							window.initEqualizeContent('.codesm-equalize-content');
						}
					} else {
						container.html('<div class="row"><div class="columns large-12 text-center"><p>Error loading documents.</p></div></div>');
					}
				},
				error: function () {
					container.html('<div class="row"><div class="columns large-12 text-center"><p>Error loading documents.</p></div></div>');
				}
			});
		});
	}
	/* ------------------------------------------------------------------------
	 * QUICK LINKS ACTIVE STATE
	 * ------------------------------------------------------------------------ */
	function updateActiveQuickLink() {
		var hash = window.location.hash;
		jQuery('.quick-link-item').removeClass('active-link');
		if (hash) {
			jQuery('.quick-link-item[href="' + hash + '"]').addClass('active-link');
		}
	}

	// Update on page load
	updateActiveQuickLink();

	// Update on hash change
	jQuery(window).on('hashchange', updateActiveQuickLink);

	// Also update when clicking a quick link (for smoother immediate feedback)
	jQuery('.quick-link-item').on('click', function () {
		jQuery('.quick-link-item').removeClass('active-link');
		jQuery(this).addClass('active-link');
	});
});



/** ======= DO NOT EDIT BELOW THIS POINT UNLESS NECESSARY ======= *
 *  ----------------- THEME FUNCTIONS - START ------------------- *
 *  ======= DO NOT EDIT BELOW THIS POINT UNLESS NECESSARY ======= */
function triggerThemeFunctions() {
	// REMOVE EMPTY P TAGS CREATED BY WP INSIDE OF ACCORDION AND ORBIT
	jQuery('.accordion p:empty, .orbit p:empty').remove();

	// ADD FLEX VIDEO TO YOUTUBE AND VIMEO EMBEDS
	jQuery(':not(.responsive-embed):not(.flex-video)>iframe[src*="youtube.com"], :not(.responsive-embed):not(.flex-video)>iframe[src*="vimeo.com"]').each(function () {
		if (jQuery(this).innerWidth() / jQuery(this).innerHeight() > 1.5) {
			jQuery(this).wrap("<div class='widescreen responsive-embed'/>");
		} else {
			jQuery(this).wrap("<div class='responsive-embed'/>");
		}
	});

	// ENABLE PSEUDO ELEMENTS FOR FONT AWESOME
	window.FontAwesomeConfig = {
		searchPseudoElements: true
	};

	// DISABLE FIRST OPTION
	jQuery('select.disable-first-option').each(function () {
		jQuery(this).find('option').first().attr('disabled', 'disabled');
	});

	// HANDLE DATA-HREF
	window.setHrefs();

	// TRIGGER EQUALIZER
	window.initEqualizeContent(EQUALIZE_CONTENT);

	// INTL-TEL-INPUT
	window.initTelephoneInput(PHONE_FIELD, THEME_FOLDER);

	// ENABLE NEGATIVE MARGINS
	window.enableNegativeMargins();

	// FOUNDATION DATEPICKER
	window.initDatepickerInput(DATEPICKER_FIELD, DATEPICKER_FORMAT);

	// // ENABLE CALLRAIL TRACKING
	// window.enableCallrailTracking();
}
/** ======= DO NOT EDIT ABOVE THIS POINT UNLESS NECESSARY ======= *
 *  ------------------ THEME FUNCTIONS - END -------------------- *
 *  ======= DO NOT EDIT ABOVE THIS POINT UNLESS NECESSARY ======= */

document.addEventListener('DOMContentLoaded', function () {
	const input = document.getElementById('image-upload');
	if (input) {
		input.addEventListener('change', function () {
			validateResumeFile(this);
		});
	}
});

function validateResumeFile(input) {
	const file = input.files[0];
	const errorBox = document.getElementById('resume-error');
	const displayBox = document.getElementById('resume-info');

	errorBox.textContent = '';
	displayBox.textContent = '';

	if (!file) return;

	const allowedTypes = [
		'application/pdf',
		'image/jpeg',
		'image/png',
		'image/jpg',
	];

	const maxSize = 10 * 1024 * 1024;

	if (!allowedTypes.includes(file.type)) {
		errorBox.textContent = '❌ Invalid file type. Allowed: PDF, JPG, PNG.';
		input.value = '';
		return;
	}

	if (file.size > maxSize) {
		errorBox.textContent = '❌ File too large. Max file size is 10MB.';
		input.value = '';
		return;
	}

	errorBox.style.color = 'green';
	errorBox.textContent = '✔ File ready to upload';
	displayBox.textContent = 'Uploaded file: ' + file.name;
}